export const FIND_SPEC_YEARS_SUCCESS = 'FIND_SPEC_YEARS_SUCCESS';

export const findSpecYearsSuccess = ({ specYears }) => ({
    type: FIND_SPEC_YEARS_SUCCESS,
    payload: { specYears },

});
